import React, { Component } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper components
import { Autoplay, Thumbs, Mousewheel } from "swiper/modules"; // Import necessary Swiper modules
import "swiper/swiper-bundle.css"; // Import Swiper styles
import { withCookies } from "react-cookie";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { isMobile } from "../Helper";
import { Search, Play } from "lucide-react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import CustomLoader from "../CustomLoader";
import Adjust from "@adjustcom/adjust-web-sdk";


const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: #1b2336;
`;
const PaginationButton = styled.div`
  background-color: #1c1e22;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #7f898c;
  font-weight: bold;
  z-index: 1;
  padding: 5px;
`;
const AllButtonTopTitleContainer = styled.div`
  background-color: #1c1e22;
  border-radius: 15px;
  display: flex;
  justify-caontent: center;
  align-items: center;
  color: #7f898c;
  font-weight: bold;
  z-index: 1;
  padding: 5px 20px;
  margin: 0;
  cursor: pointer;

  @media (max-width: 350px) {
    display: none;
  }
`;
const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #1b1e22;
  border-radius: 30px;
  padding: 12px 16px;
  width: 100%;
  max-width: 300px;
  transition: outline 0.2s ease-in-out;
  border: ${(props) =>
    props.isFocused ? "2px solid #4caf50" : "2px solid transparent"};

  @media (min-width: 200px) and (max-width: 500px) {
    max-width: 600px;
  }
`;
const SearchInput = styled.input`
  background-color: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  margin-left: 8px;
  outline: none;

  &::placeholder {
    color: #a0a0a0;
  }
`;

const FullScreenIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: ${(props) => (props.loading ? "none" : "block")};
`;
const ResponsiveImage = styled.img`
  object-fit: fill;
  width: 100%;
  height: 188px;
  border-radius: 20px;

  @media (min-width: 467px) {
    width: 100%;
    height: 188px;
  }
`;

const BackButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background: none;
  border: none;
  color: #000;
  font-size: 24px;
  cursor: pointer;
`;

const GamesTopWrapper = styled.div`
  //   background-color: #1c1e22;
  //   padding: 2px;
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  position: relative;
  margin-top: 40px !important;
  background-color: transparent;
  @media (max-width: 768px) {
    margin-top: 50px !important;
  }
`;
const GridContainer = styled.div`
  display: grid;
  gap: 10px;
  padding: 0rem;
  margin: 12px 12px;
  width: 100%;
  // Mobile view (2 columns)
  grid-template-columns: repeat(2, 1fr);
  // Tablet view (3 columns)
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  // Desktop view (4 columns)
  @media (min-width: 1068px) {
    grid-template-columns: repeat(7, 1fr);
  }
`;
const GridItem = styled.div`
  position: relative;
  background-color: transparent;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
`;

const ImageWrapper = styled.div`
  position: relative;
  border-radius: 10px;

  /* Hover overlay effect */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0); /* No overlay initially */
    transition: background 0.3s ease;
    pointer-events: none; /* Allow pointer events to pass through */
  }

  /* Darker overlay on hover */
  &:hover::before {
    background: rgba(0, 0, 0, 0.4);
  }
`;

const GridContainerNew = styled.div`
  display: grid;
  gap: 20px;
  padding: 0rem;
  margin: 12px 12px;
  width: 100%;
  border-radius: 15px !important;
  padding-right: 17px;
  // Mobile view (2 columns)
  grid-template-columns: repeat(2, 1fr) !important;
  // Tablet view (3 columns)
  @media (min-width: 480px) {
    grid-template-columns: repeat(3, 1fr) !important;
  }
  @media (min-width: 870px) {
    grid-template-columns: repeat(4, 1fr) !important;
  }
  // Desktop view (4 columns)
  @media (min-width: 1068px) {
    grid-template-columns: repeat(5, 1fr) !important;
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(7, 1fr) !important;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const Title = styled.h3`
  padding: 0.5rem;
  margin: 0;
  font-size: 10px;
  text-align: left;
  color: rgb(152, 167, 181);
`;
const TopTitleContainer = styled.h3`
  background-color: #1c1e22;
  border-radius: 15px;
  position: absolute;
  top: -71px;
  left: 0;
  z-index: 1;
  padding: 10px;
  margin: 0;
`;
const AllButtonRigthTitleContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 10px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  top: -44px; //vivek
  // right: 0;
  color: #7f898c;
  font-weight: bold;
  z-index: 1;
  margin: 0;
`;

class GamesSwiperOther extends Component {
  constructor(props) {
    super(props);
    this.state = {
      padding: "py-2",
      selectedSection: "home",
      sectionIndex: 0,
      slideSelected: null,
      gamesEvolution: [],
      currentPageJillie: 0, // Track current page
      itemsPerPageJillie: 10, // Number of items per page
      gamesJillie: [],
      gamesJdb: [],
      gamesPragmatic: [],
      gamesPragmaticlive: [],
      gamesEvoplay: [],
      gamesGenisis: [],
      gamesPgsoft: [],
      gamesLiveCasinoProvider: [],
      gamesSpribe: [],
      gamesSports: [],
      gamesMostExpensive: [],
      error: null,
      loading: false,
      message: null,
      showMore: false,
      showMoreP: false,
      showMoreO: false,
      showMoreLCP: false,
      showMoreSP: false,
      showMoreSB: false,
      isMobileView: window.innerWidth <= 768,
      searchQuery: "",
      showIframe: false,
      iframeUrl: "",
      iframeLoading: true,
      showAll: false,
      showAllData: false,

      activeItem: "Lobby",
      searchQuery2: "",
      collapsedProviders: {},
      loading: false,
      showIframe: false,
      iframeUrl: null,
      iframeLoading: false,
      message: null,
      showFullScreenLoader: false, // <-- New state flag
    };

    this.swiperRef = React.createRef();

    this.sections = [
      "/assets/images/evolutionicon.png",
      "/assets/images/ezubi.png",
      "/assets/images/pragmatic.png",
      "/assets/images/netent.png",
      "/assets/images/novomatic.png",
    ];
    this.livecasino = [
      "/assets/images/live1.png",
      "/assets/images/live2.png",
      "/assets/images/live3.jpg",
      "/assets/images/live4.jpg",
      "/assets/images/live5.jpg",
      "/assets/images/live6.png",
    ];
    this.itemsToShow = 5;
    this.containerPlayRef = React.createRef();
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }
  nextSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    } else {
      console.warn("Swiper not initialized yet");
    }
  };

  prevSlideHandler = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    } else {
      console.warn("Swiper not initialized yet");
    }
  };

  filterGames = (games, query) => {
    if (!query) return games;

    const normalizedQuery = query.toLowerCase(); // normalize search term

    return games.filter((game) => {
      const { game_id, game_name } = game;
      const { first, second, third } = this.getTitleWB(Number(game_id));
      const titleString = `${first} ${second} ${third}`.toLowerCase();

      return (
        game_name.toLowerCase().includes(normalizedQuery) ||
        titleString.includes(normalizedQuery)
      );
    });
  };


  getTitleWB = (gType) => {
    switch (gType) {
      case 1:
        return { first: "Evolution", second: "Asia", third: "Games" };
      case 2:
        return { first: "Big", second: "Gaming", third: "Games" };
      case 3:
        return { first: "Micro Gaming", second: "Live", third: "Games" };
      case 5:
        return { first: "Asia", second: "Gaming", third: "Games" };
      case 6:
        return { first: "Dream", second: "Gaming", third: "Games" };
      case 9:
        return { first: "Sexy", second: "Gaming", third: "Games" };
      case 10:
        return { first: "Pragmatic", second: "Play", third: "Games" };
      case 11:
        return { first: "Live", second: "88", third: "Games" };
      case 12:
        return { first: "Playtech", second: "Live", third: "Games" };
      case 17:
        return { first: "Ezugi", second: "Live", third: "Games" };
      case 19:
        return { first: "Skywind", second: "Live", third: "Games" };
      case 28:
        return { first: "PragmaticPlay", second: "Live", third: "Games" };
      case 40:
        return { first: "Evolution", second: "SEA", third: "Games" };
      case 41:
        return { first: "Bet", second: "games", third: "Games" };
      case 100:
        return {
          first: "Illustrate Analytics",
          second: "Sports",
          third: "Games",
        };
      case 105:
        return { first: "BTI", second: "Sports", third: "Games" };
      case 200:
        return { first: "PP", second: "Slot", third: "Games" };
      case 201:
        return { first: "Habanero", second: "All", third: "Games" };
      case 202:
        return { first: "Elysium", second: "All", third: "Games" };
      case 205:
        return { first: "Spade", second: "Gaming", third: "Games" };
      case 207:
        return { first: "Play'N Go", second: "All", third: "Games" };
      case 208:
        return { first: "World", second: "Match", third: "Games" };
      case 209:
        return { first: "Micro Gaming", second: "Slot", third: "Games" };
      case 211:
        return { first: "OneTouch", second: "All", third: "Games" };
      case 213:
        return { first: "Red Tiger", second: "Asia", third: "Games" };
      case 214:
        return { first: "Netent", second: "Asia", third: "Games" };
      case 216:
        return { first: "YGGDrasil", second: "All", third: "Games" };
      case 217:
        return { first: "BNG", second: "All", third: "Games" };
      case 218:
        return { first: "Playson", second: "All", third: "Games" };
      case 219:
        return { first: "Playtech", second: "Slot", third: "Games" };
      case 220:
        return { first: "CQ9", second: "Slot", third: "Games" };
      case 221:
        return { first: "Skywind", second: "Slot", third: "Games" };
      case 222:
        return { first: "Wazdan", second: "All", third: "Games" };
      case 223:
        return { first: "PG", second: "Soft", third: "Games" };
      case 225:
        return { first: "Big Time Gaming", second: "Asia", third: "Games" };
      case 226:
        return { first: "Pragmatic Play", second: "Slot", third: "Games" };
      case 227:
        return { first: "No Limit City", second: "Asia", third: "Games" };
      case 229:
        return { first: "Relax", second: "Gaming", third: "Games" };
      case 231:
        return { first: "NextSpin", second: "Gaming", third: "Games" };
      case 232:
        return { first: "Spinix", second: "All", third: "Games" };
      case 249:
        return { first: "Naga", second: "All", third: "Games" };
      case 255:
        return { first: "Hacksaw", second: "Gaming", third: "Games" };
      case 263:
        return { first: "JiLi", second: "All", third: "Games" };
      case 271:
        return { first: "Booming", second: "All", third: "Games" };
      case 300:
        return { first: "Spribe", second: "All", third: "Games" };
      case 302:
        return { first: "Alize", second: "All", third: "Games" };
      case 303:
        return { first: "Aviatrix", second: "All", third: "Games" };
      case 304:
        return { first: "Fast", second: "Game", third: "Games" };
      default:
        return { first: "WB", second: "Other", third: "Games" };
    }
  };

  handleGameLaunchWB = async (game, categoryId) => {
    this.setState({ loading: true, message: null, showFullScreenLoader: true });

    try {
      const { cookies } = this.props;
      const uid = cookies.get("uid");

      if (!uid) {
        throw new Error("Please login to play live game");
      }
      const response = await fetch(
        "https://api.trubetx.com/launchFTGame",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ uid: String(uid), game_uid: game.game_uid, gameId: game.id }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      console.log(result, "result");
      console.log(result.data, "resultData");

      if (result?.launchUrl) {
        // 🔥 Adjust GAMEPLAY event
        if (window.Adjust) {
          Adjust.trackEvent("grrfc3"); // gameplay
        }
        this.setState({
          iframeUrl: result.launchUrl,
          showIframe: true,
          iframeLoading: true,
        });
      } else {
        throw new Error("Unexpected response from server");
      }
    } catch (error) {
      this.setState({ message: { type: "error", text: error.message } });
    } finally {
      this.setState({ loading: false, showFullScreenLoader: false });
      setTimeout(() => {
        this.setState({ message: null });
      }, 5000);
    }
  };


  handleShowAllData = () => {
    this.setState((prevState) => ({ showAllData: !prevState.showAllData }));
  };

  handleMouseDown(e) {
    this.isDown = true;
    this.startX = e.pageX - this.containerPlayRef.current.offsetLeft;
    this.scrollLeft = this.containerPlayRef.current.scrollLeft;
  }

  handleShowAllClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    this.setState({ showAll: !this.state.showAll });
  };

  handleMouseLeave() {
    this.isDown = false;
  }

  handleMouseUp() {
    this.isDown = false;
  }

  handleMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.containerPlayRef.current.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.containerPlayRef.current.scrollLeft = this.scrollLeft - walk;
  }
  handleItemClick = (item) => {
    this.setState({ activeItem: item });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.activeItem !== this.state.activeItem) {
      console.log(`Active item changed to: ${this.state.activeItem}`);
      // Add any additional side effects or logic you want to run on activeItem change
    }
  }

  componentDidMount() {
    const containerPlay = this.containerPlayRef.current;
    containerPlay.addEventListener("mousedown", this.handleMouseDown);
    containerPlay.addEventListener("mouseleave", this.handleMouseLeave);
    containerPlay.addEventListener("mouseup", this.handleMouseUp);
    containerPlay.addEventListener("mousemove", this.handleMouseMove);
  }

  componentWillUnmount() {
    const containerPlay = this.containerPlayRef.current;
    containerPlay.removeEventListener("mousedown", this.handleMouseDown);
    containerPlay.removeEventListener("mouseleave", this.handleMouseLeave);
    containerPlay.removeEventListener("mouseup", this.handleMouseUp);
    containerPlay.removeEventListener("mousemove", this.handleMouseMove);
  }

  handleBackButton = () => {
    this.setState({ showIframe: false, iframeUrl: "", iframeLoading: true });
  };

  handleIframeLoad = () => {
    this.setState({ iframeLoading: false });
  };

  componentDidMount() {
    this._isMounted = true;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (isMobile()) {
      this.setState({ padding: "p-1" });
    }

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this._isMounted = false;
  }

  handleResize = () => {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    this.setState({ isMobileView: width <= 768 });
  };

  handleClick = (e) => {
    this.setState({ selectedSection: e });
  };

  handleArrowClick = (direction) => {
    const { sectionIndex } = this.state;
    const { sections, itemsToShow } = this;
    const totalSections = sections.length;

    let newIndex;

    if (direction === "left") {
      newIndex = (sectionIndex - itemsToShow + totalSections) % totalSections;
    } else {
      newIndex = (sectionIndex + itemsToShow) % totalSections;
    }

    this.setState({
      selectedSection: sections[newIndex],
      sectionIndex: newIndex,
    });
  };

  handleShowMore = () => {
    this.setState({ showMore: !this.state.showMore });
  };

  handleShowMoreP = () => {
    this.setState({ showMoreP: !this.state.showMoreP });
  };

  handleShowMoreO = () => {
    this.setState({ showMoreO: !this.state.showMoreO });
  };

  handleShowMoreLCP = () => {
    this.setState({ showMoreLCP: !this.state.showMoreLCP });
  };

  handleShowMoreSP = () => {
    this.setState({ showMoreSP: !this.state.showMoreSP });
  };

  handleShowMoreSB = () => {
    this.setState({ showMoreSB: !this.state.showMoreSB });
  };

  handlePreviousPage = () => {
    this.setState((prevState) => ({
      currentPageJillie: Math.max(prevState.currentPageJillie - 1, 0), // Prevent going below page 0
    }));
  };

  handleNextPage = () => {
    this.setState((prevState) => ({
      currentPageJillie: Math.min(
        prevState.currentPageJillie + 1,
        Math.ceil(prevState.gamesJillie.length / prevState.itemsPerPageJillie) -
        1 // Correctly access gamesJillie from state
      ),
    }));
  };
  toggleProviderVisibility = (gType) => {
    this.setState((prevState) => ({
      collapsedProviders: {
        ...prevState.collapsedProviders,
        [gType]: !prevState.collapsedProviders[gType],
      },
    }));
  };
  render() {
    const { gameData, category, searchQuery2 } = this.props;
    console.log(searchQuery2);
    // Find the category in gameData
    const selectedCategoryData = gameData.find(
      (item) => item.category === category
    );
    console.log(selectedCategoryData);

    // If category is found, extract the game_list, otherwise use an empty object or array as fallback
    const game_list = selectedCategoryData
      ? selectedCategoryData.game_list
      : {};
    console.log(game_list);
    // If selectedCategory is undefined, fallback to an empty array for safe mapping

    const { showIframe, iframeUrl, iframeLoading } = this.state;
    let { content, t } = this.props;
    const { collapsedProviders } = this.state;

    const imageStyle = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "250px",
      animation: "fadeinout 2s infinite",
    };
    const animationStyle = `
      @keyframes fadeinout {
        0%, 100% { opacity: 0; }
        50% { opacity: 1; }
      }
    `;
    if (showIframe) {
      return (
        <FullScreenContainer>
          <style>{animationStyle}</style>
          {this.state.iframeLoading && (
            <img
              loading="lazy"
              src={process.env.REACT_APP_LG_LOGO}
              alt="Loading"
              style={imageStyle}
            />
          )}
          <FullScreenIframe
            src={iframeUrl}
            title="Game Iframe"
            onLoad={this.handleIframeLoad}
            loading={this.state.iframeLoading}
          />
          <BackButton
            style={{ color: "white" }}
            onClick={this.handleBackButton}
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </BackButton>
        </FullScreenContainer>
      );
    }

    function generateGradient(gameName) {
      // Convert the game name into a hash or use any string-based property
      const hash = [...gameName].reduce(
        (acc, char) => acc + char.charCodeAt(0),
        0
      );
      const hue = hash % 360; // Use the hash to generate a unique hue value

      // Return a gradient based on the generated hue
      return `linear-gradient(45deg, hsl(${hue}, 100%, 60%), hsl(${(hue + 90) % 360
        }, 100%, 60%))`;
    }
    const filteredGames = Object.keys(game_list).flatMap(
      (gType) =>
        this.filterGames(game_list[gType], searchQuery2)
          .filter((game) => game.game_name !== "N/A" && game.is_enabled !== 0)
          .map((game) => ({ ...game, gType })) // Add gType to each game object
    );

    if (filteredGames.length === 0) return null;

    return (
      <div style={{ marginTop: "10px" }}>
        {this.state.showFullScreenLoader && <CustomLoader />}
        <GamesTopWrapper>
          <AllButtonRigthTitleContainer>
            <div style={{ display: "flex" }}>
              <div
                className="bc-slider-text"
                style={{
                  color: "white",
                  fontSize: "17px",
                  fontWeight: "bold",
                  marginLeft: "15px",
                }}
              >
                {
                  category === "inout"
                    ? "inout"
                    :
                    category === "sport2"
                      ? "Sport"
                      : "Other Games"}
              </div>
            </div>
            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
              {/* <p style={{ fontSize: "15px" }}>
                                                            Games: {totalGames}
                                                        </p> */}
              <div style={{ display: "flex", gap: "10px" }}>
                <Link to={category === "spribe" ? "/providers/300" : category === "live-casino" ? "/providers/1" : category === "slots" ? "/providers/263" : category === "hot-games" ? "/providers/100" : category === "sports" ? "/providers/105" : category === "Originals" ? "/providers/300" : category === "Evolution" ? "/providers/1" : category === "Ezugi" ? "/providers/17" : "/all-games"}>
                  <AllButtonTopTitleContainer>Show More</AllButtonTopTitleContainer>
                </Link>
                <div
                  style={{ display: "flex", gap: "4px", alignItems: "center" }}
                >
                  <PaginationButton onClick={this.prevSlideHandler}>
                    <ChevronLeft size={20} />
                  </PaginationButton>

                  <PaginationButton onClick={this.nextSlideHandler}>
                    <ChevronRight size={20} />
                  </PaginationButton>
                </div>
              </div>
            </div>
          </AllButtonRigthTitleContainer>
          <Swiper
            slidesPerView={7}
            ref={this.swiperRef}
            spaceBetween={10}
            modules={[Autoplay, Thumbs, Mousewheel, Scrollbar]}
            loop={true}
            thumbs={true}
            breakpoints={{
              1600: { slidesPerView: 10 },   // Extra large desktops
              1366: { slidesPerView: 9.4 },    // Standard desktops/laptops
              1200: { slidesPerView: 7 },
              1024: { slidesPerView: 6 },    // Tablets (landscape)
              900: { slidesPerView: 5 },
              768: { slidesPerView: 4 },     // Tablets (portrait)
              600: { slidesPerView: 3 },
              480: { slidesPerView: 3 },   // Large phones
              360: { slidesPerView: 3 },     // Medium phones
              0: { slidesPerView: 1 },       // Smallest devices
            }}

          >
            {category !== "Originals" ? (
              <GridContainerNew>
                {Object.keys(game_list)
                  .flatMap(
                    (gType) =>
                      this.filterGames(game_list[gType], searchQuery2)
                        .filter(
                          (game) =>
                            game.game_name !== "N/A" && game.is_enabled !== 0
                        )
                        .map((game) => ({ ...game, gType })) // Add gType to each game object
                  )
                  .sort((a, b) =>
                    a.gType === "300" ? -1 : b.gType === "300" ? 1 : 0
                  ) // Prioritize gType === "300"
                  .slice(0, 30)
                  .map((game) => (
                    <SwiperSlide key={game.id}>
                      <GridItem key={game.id}>
                        <ImageWrapper>
                          {game.icon ? (


                            <div
                              style={{
                                width: "115px",
                                height: "160px",
                                position: "relative",
                                overflow: "hidden",
                                cursor: "pointer"
                              }}
                              onClick={() => this.handleGameLaunchWB(game)}
                              className="game-container"
                            >
                              <img
                                loading="lazy"
                                src={game?.icon}
                                alt="game"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  display: "block"
                                }}
                              />
                              <div className="hover-overlay">
                                <div className="play-button">
                                  <Play size={32} color="white" />
                                </div>
                              </div>

                              <style jsx>{`
                             .game-container:hover .hover-overlay {
                               opacity: 1;
                             }
                         
                             .hover-overlay {
                               position: absolute;
                               top: 0;
                               left: 0;
                               width: 100%;
                               height: 100%;
                               backdrop-filter: blur(4px);
                               background-color: rgba(0, 0, 0, 0.3);
                               display: flex;
                               align-items: center;
                               justify-content: center;
                               opacity: 0;
                               transition: opacity 0.3s ease;
                             }
                         
                             .play-button {
                               background-color: rgba(0, 0, 0, 0.6);
                               border-radius: 50%;
                               padding: 10px;
                               display: flex;
                               align-items: center;
                               justify-content: center;
                             }
                           `}</style>
                            </div>

                          ) : (

                            <div
                              style={{
                                width: "115px",
                                height: "160px",
                                position: "relative",
                                overflow: "hidden",
                                cursor: "pointer"
                              }}
                              onClick={() => this.handleGameLaunchWB(game, game.gType)}
                              className="game-container"
                            >
                              <img
                                loading="lazy"
                                src={game?.icon}
                                alt="game"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  display: "block"
                                }}
                              />
                              <div className="hover-overlay">
                                <div className="play-button">
                                  <Play size={32} color="white" />
                                </div>
                              </div>

                              <style jsx>{`
                              .game-container:hover .hover-overlay {
                                opacity: 1;
                              }

                              .hover-overlay {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 100%;
                                backdrop-filter: blur(4px);
                                background-color: rgba(0, 0, 0, 0.3);
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                opacity: 0;
                                transition: opacity 0.3s ease;
                              }

                              .play-button {
                                background-color: rgba(0, 0, 0, 0.6);
                                border-radius: 50%;
                                padding: 10px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                              }
                            `}</style>
                            </div>

                          )}
                        </ImageWrapper>
                      </GridItem>
                    </SwiperSlide>
                  ))}
              </GridContainerNew>
            ) : (
              // Content to render when category === "Originals" (you can replace this with your own JSX)
              <GridContainerNew>
                {console.log(game_list)}{" "}
                {/* Logs game_list in the "Originals" category */}
                {Object.keys(game_list).flatMap((gType) =>
                  game_list[gType] // Access games from each category
                    .filter((game) => game.is_enabled !== 0) // Filter enabled games
                    .filter(
                      (game) =>
                        game.game_name
                          .toLowerCase()
                          .includes(searchQuery2.toLowerCase()) // Apply searchQuery2 filter
                    )
                    .map((game, index) => (
                      <SwiperSlide key={index}>
                        <GridItem>
                          <Link to={`/${game.game_name}`}>
                            <ImageWrapper>

                              <div
                                style={{
                                  width: "115px",
                                  height: "160px",
                                  position: "relative",
                                  overflow: "hidden",
                                  cursor: "pointer"
                                }}
                                className="game-container"
                              >
                                <img
                                  loading="lazy"
                                  src={game?.game_icon_link}
                                  alt="game"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block"
                                  }}
                                />
                                <div className="hover-overlay">
                                  <div className="play-button">
                                    <Play size={32} color="white" />
                                  </div>
                                </div>

                                <style jsx>{`
                                .game-container:hover .hover-overlay {
                                  opacity: 1;
                                }

                                .hover-overlay {
                                  position: absolute;
                                  top: 0;
                                  left: 0;
                                  width: 100%;
                                  height: 100%;
                                  backdrop-filter: blur(4px);
                                  background-color: rgba(0, 0, 0, 0.3);
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  opacity: 0;
                                  transition: opacity 0.3s ease;
                                }

                                .play-button {
                                  background-color: rgba(0, 0, 0, 0.6);
                                  border-radius: 50%;
                                  padding: 10px;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                }
                              `}</style>
                              </div>

                            </ImageWrapper>
                          </Link>
                        </GridItem>
                      </SwiperSlide>
                    ))
                )}
              </GridContainerNew>
            )}
          </Swiper>
        </GamesTopWrapper>
      </div>
    );
  }
}

export default withCookies(GamesSwiperOther);
